export default "__VITE_ASSET__B71Cb1jo__"